import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(4, 0, 4),
  },
  toolBar: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  formField: {
    marginBottom: theme.spacing(0),
  },
  // lockIcon: {
  //   backgroundColor: theme.palette.primary.main,
  // },
  modalFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    width: '100%',
  },
});

function Modal({
  classes,
  setActiveModal,
  title,
  onFormSubmit,
  formContents,
  footerContents,
  buttonText,
  containerMaxWidth = 'xs',
}) {
  const onCloseModal = () => {
    setActiveModal('none');
  };

  return (
    <Container component="main" maxWidth={containerMaxWidth} disableGutters>
      <Toolbar className={classes.toolBar} disableGutters>
        <IconButton
          edge="start"
          color="inherit"
          onClick={onCloseModal}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon className={classes.lockIcon} />
        </Avatar>

        <Typography component="h1" variant="h5" className={classes.title}>
          {title}
        </Typography>

        <form onSubmit={onFormSubmit} className={classes.form}>
          {formContents}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {buttonText}
          </Button>
        </form>

        {footerContents && (
          <div className={classes.modalFooter}>{footerContents}</div>
        )}
      </div>
    </Container>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(withStyles(styles)(Modal));
